module.exports = __webpack_public_path__ + "img/Somalia_Certificate.b04774bf.jpg";